import { render, staticRenderFns } from "./PointCreditCancel.vue?vue&type=template&id=0f5cd31f"
import script from "./PointCreditCancel.vue?vue&type=script&lang=js"
export * from "./PointCreditCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports